/**
 * Configuration utilities for web components
 */

/**
 * Gets the API base URL from environment variables or returns the default value
 * @param apiBaseUrl - Optional API base URL passed as parameter
 * @returns The API base URL
 */
export const getApiBaseUrl = (apiBaseUrl?: string): string => {
  // Priority 1: Parameter passed directly (highest priority)
  if (apiBaseUrl) {
    return apiBaseUrl;
  }

  // Priority 2: Runtime configuration
  if (
    typeof window !== "undefined" &&
    (window as any).FleetManagerConfig?.apiBaseUrl
  ) {
    console.log(
      "Using runtime config:",
      (window as any).FleetManagerConfig.apiBaseUrl,
    );
    return (window as any).FleetManagerConfig.apiBaseUrl;
  }

  // Priority 3: Environment variable (build time)
  try {
    const envUrl = (import.meta as any).env?.VITE_API_BASE_URL;
    if (envUrl) {
      console.log("Using environment variable:", envUrl);
      return envUrl;
    }
  } catch (error) {
    console.log("import.meta.env not available:", error);
  }

  // Priority 4: Default value (fallback)
  console.log("Using default URL: http://localhost:4007/v1");
  return "https://fms-api.spot2nite.xyz/v1";
};

/**
 * Configuration object that can be set at runtime
 */
export interface FleetManagerConfig {
  apiBaseUrl?: string;
}

/**
 * Sets the configuration at runtime
 * @param config Configuration object
 */
export const setConfig = (config: FleetManagerConfig): void => {
  if (typeof window !== "undefined") {
    (window as any).FleetManagerConfig = {
      ...((window as any).FleetManagerConfig || {}),
      ...config,
    };
  }
};

/**
 * Gets the current configuration
 * @returns Current configuration object
 */
export const getConfig = (): FleetManagerConfig => {
  if (typeof window !== "undefined") {
    return (window as any).FleetManagerConfig || {};
  }
  return {};
};
